import { render, staticRenderFns } from "./PaymentTermsModal.vue?vue&type=template&id=dff8ad40&scoped=true"
import script from "./PaymentTermsModal.vue?vue&type=script&lang=js"
export * from "./PaymentTermsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff8ad40",
  null
  
)

export default component.exports